import { City, Country, State } from "country-state-city";
import { useFormik } from "formik";
import { getCode } from "iso-3166-1-alpha-2";
import React from "react";
import "react-country-state-city/dist/react-country-state-city.css";
import { BiEdit } from "react-icons/bi";
import { MdEdit } from "react-icons/md";
import { toast } from "react-toastify";
import * as Yup from "yup";
import api from "../../../api/auth_api";
import orgApi from "../../../api/org_api";
import {
  Breadcrumb,
  Button,
  CustomInput,
  IconButton,
  Label,
  Modal,
  SearchableDropdown,
} from "../../../component/common";
const OrgProfile: React.FC<{ setLoading: Function }> = ({ setLoading }) => {
  const [userData, setUserData] = React.useState({} as any);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const prevImage = userData?.profile_pic;
  const [fileError, setfileError] = React.useState("");
  const [edit1, setEdit1] = React.useState(false);
  const [edit2, setEdit2] = React.useState(true);
  const [orgId, setOrgId] = React.useState("");
  const [isImageSelect, setIsImageSelect] = React.useState(false);
  const [changePass, setChangePass] = React.useState(false);

  React.useEffect(() => {
    fetchProfileData();
  }, []);

  const fetchProfileData = async () => {
    const org = JSON.parse(localStorage.getItem("user__details")?.toString()!);
    setOrgId(org.id);
    setLoading(true);
    const res = await orgApi.getOrgDetails(org.id);
    if (res.data.success) {
      setLoading(false);
      setUserData(res.data.org);
      setData(res.data.org);
      localStorage.setItem("user__details", JSON.stringify(res.data.org));
    }
  };

  const setData = async (userData: any) => {
    formik.resetForm();
    if (userData) {
      const countryC = await getCountryCode(userData.country);
      const coun = Country.getCountryByCode(countryC!);
      formik.setFieldValue("country", coun);
      const states = State.getStatesOfCountry(countryC!);
      const state = states.find((state) => state.name === userData.state);
      formik.setFieldValue("state", state);
      const cities = City.getCitiesOfState(countryC!, state?.isoCode!);
      const city = cities.find((city) => city.name === userData.city);
      formik.setFieldValue("city", city);
      setSelectedImage(userData.profile_pic);
      formik.setFieldValue("organization", userData.org_name);
      formik.setFieldValue("orgwebsiteurl", userData.org_web_url);
      formik.setFieldValue("organizationSize", userData.size);
      formik.setFieldValue("postal_code", userData.postal_code);
      formik.setFieldValue("first_name", userData.first_name);
      formik.setFieldValue("last_name", userData.last_name);
      formik.setFieldValue("emailId", userData.email);
      formik.setFieldValue("phoneNumber", userData.mobile);
    }
  };

  const getCountryCode = async (countryName: string) => {
    var code = await getCode(countryName);
    return code;
  };

  const handleImageChange = (event: any) => {
    setfileError("");
    const file = event.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        if (file.size <= 2 * 1024 * 1024) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            setSelectedImage(e.target.result);
            setfileError("");
          };
          reader.readAsDataURL(file);
          setIsImageSelect(true);
        } else {
          setfileError(
            "File size exceeds the limit. Please select a smaller file.",
          );
        }
      } else {
        setfileError("Please select an image file.");
      }
    }
  };

  const updateProfilePic = async () => {
    const formData = new FormData();
    if (isImageSelect) {
      var file = dataURLtoFile(
        selectedImage,
        Math.random().toString(36).substring(6) + "_name.png",
      );
      formData.append("profile", file);
      setLoading(true);
      const res = await api.updateProfile(formData, orgId);
      if (res.data.success === true) {
        fetchProfileData();
        setIsImageSelect(false);
        // setEdit1(true);
        toast("Profile picture successfully updated");
      } else {
        toast(res.data.msg);
      }
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      organization: "",
      organizationSize: "",
      orgwebsiteurl: "",
      country: null,
      state: null,
      city: null,
      postal_code: "",
      first_name: "",
      last_name: "",
      emailId: "",
      phoneNumber: "",
    },
    validationSchema: Yup.object({
      organizationSize: Yup.string().required("Organization Size is required"),
      orgwebsiteurl: Yup.string().url(
        "Organization website url must be a valid URL",
      ),
      country: Yup.object().required("Country is required"),
      state: Yup.object().required("State is required"),
      city: Yup.object().required("City is required"),
      postal_code: Yup.string()
        .required("Postal Code is required")
        .matches(/^(?=.*\d).*$/, "Postal Code must contain Numbers")
        .min(6, "Postal Code must have 6 character")
        .max(6, "Postal Code must have 6 character"),
      first_name: Yup.string().required("First name is required"),
      last_name: Yup.string().required("Last name is required"),
      emailId: Yup.string(),
      phoneNumber: Yup.string(),
    }),
    validateOnBlur: true,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("org_web_url", values.orgwebsiteurl);
      formData.append("size", values.organizationSize);
      formData.append("country", values.country?.["name"]!);
      formData.append("state", values.state?.["name"]!);
      formData.append("city", values.city?.["name"]!);
      formData.append("postal_code", values.postal_code);
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      setLoading(true);
      const res = await api.updateProfile(formData, orgId);
      if (res.data.success === true) {
        fetchProfileData();
        // setEdit1(true);
        toast("Profile Details successfully updated");
      } else {
        toast(res.data.msg);
      }
      setLoading(false);
    },
  });

  function dataURLtoFile(dataurl: any, filename: any) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const formik1 = useFormik({
    initialValues: { old_pass: "", new_pass: "", confirm_pass: "" },
    validationSchema: Yup.object({
      old_pass: Yup.string().required("Old Password is required"),
      new_pass: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .max(22, "Password must be maximum 22 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!*]).*$/,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
        )
        .required("New Password is required"),
      confirm_pass: Yup.string()
        .oneOf([Yup.ref("new_pass"), ""], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    validateOnBlur: true,
    onSubmit: async (values) => {
      setLoading(true);
      const user_id = localStorage.getItem("user_id")?.toString()!;
      var data = {
        old_password: values.old_pass,
        new_password: values.new_pass,
      };
      const res = await api.changePassword(data, user_id);
      if (res.data.success === true) {
        toast(res.data.msg);
        setChangePass(false);
        formik1.resetForm();
      } else {
        toast(res.data.msg);
      }
      setLoading(false);
    },
  });

  return (
    <>
      <div className=" h-[calc(100vh-100px)] 2xl:h-[calc(100vh-105px)] overflow-y-auto">
        <div className=" flex flex-col space-y-3 ">
          <Breadcrumb
            items={[
              { text: "Dashboard", href: "/dashboard" },
              { text: "Admin Profile", isActive: true },
            ]}
          />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <aside className="md:col-span-1">
              <div className="bg-white border border-slate-200 rounded-lg p-6">
                <div className="mb-2 pb-6 border-b border-slate-200">
                  <div className="relative mx-auto mb-4">
                    <div className=" absolute top-0 right-0 flex gap-2 mb-4">
                      <IconButton
                        onClick={() => setEdit1(true)}
                        icon={<BiEdit size={16} />}
                        color="blue"
                      />
                    </div>

                    {userData?.profile || selectedImage ? (
                      <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-slate-200 mx-auto">
                        <img
                          className="w-full h-full object-cover"
                          src={selectedImage || userData?.profile}
                          alt="Organization Logo"
                        />
                      </div>
                    ) : (
                      <div className="w-32 h-32 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 mx-auto flex items-center justify-center">
                        <svg
                          className="h-6 w-6 text-white"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                          />
                        </svg>
                      </div>
                    )}
                  </div>

                  <p className="text-sm font-medium text-slate-900 text-center">
                    {userData?.org_name}
                  </p>
                </div>
                <nav className="space-y-2">
                  <button
                    onClick={() => {
                      setChangePass(true);
                      formik1.resetForm();
                    }}
                    className="w-full text-left flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-100 transition-colors group"
                  >
                    <span className="text-sm w-full text-center font-medium text-slate-700 group-hover:text-slate-900">
                      Change Password
                    </span>
                  </button>
                </nav>
              </div>
            </aside>
            <main className="md:col-span-3 space-y-6">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-100">
                  <div className="flex justify-between items-center">
                    <p className="text-md text-gray-800">
                      Organization Details
                    </p>
                    <div className="flex space-x-2">
                      {edit2 ? (
                        <Button
                          onClick={() => setEdit2(false)}
                          text="Edit"
                          variant="outlined"
                        />
                      ) : (
                        <Button
                          onClick={() => setEdit2(true)}
                          text="Cancel"
                          variant="outlined"
                          color="red"
                        />
                      )}
                      <Button
                        type="submit"
                        form="orgDetailsForm"
                        text="Save"
                        variant="contained"
                        onClick={() => {
                          setEdit1(false);
                          setEdit2(true);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <form
                  id="orgDetailsForm"
                  onSubmit={formik.handleSubmit}
                  className="px-8  h-[calc(100vh-220px)] py-5"
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <SearchableDropdown
                      options={[
                        { value: "<10", label: "<10" },
                        { value: "11-50", label: "11 to 50" },
                        { value: "51-200", label: "51 to 200" },
                        { value: "201-500", label: "201 to 500" },
                        { value: "501-1000", label: "501 to 1000" },
                        { value: ">1000", label: ">1000" },
                      ]}
                      label="Organization Size"
                      disabled={edit2}
                      value={formik.values.organizationSize}
                      required
                      onChange={(e) =>
                        formik.setFieldValue("organizationSize", e.value)
                      }
                      isError={
                        !!formik.touched.organizationSize &&
                        !!formik.errors.organizationSize
                      }
                      errorMessage={formik.errors.organizationSize}
                    />

                    <CustomInput
                      disabled={edit2}
                      placeholder="Organization Website"
                      type="text"
                      name="orgwebsiteurl"
                      label="Organization Website"
                      value={formik.values.orgwebsiteurl}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      isError={
                        !!formik.touched.orgwebsiteurl &&
                        !!formik.errors.orgwebsiteurl
                      }
                      errorMessage={formik.errors.orgwebsiteurl}
                    />

                    <CustomInput
                      disabled
                      placeholder="Business mail"
                      type="text"
                      name="emailId"
                      label="Business mail"
                      value={formik.values.emailId}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      isError={
                        !!formik.touched.emailId && !!formik.errors.emailId
                      }
                      errorMessage={formik.errors.emailId}
                    />
                    <div className="flex flex-col gap-1.5">
                      <Label text="Country" required />
                      <SearchableDropdown
                        disabled={edit2}
                        placeholder="Select Country"
                        options={Country.getAllCountries().map(
                          (country: any) => ({
                            label: country.name,
                            value: country,
                            data: country,
                          }),
                        )}
                        value={
                          formik.values.country ? formik.values.country : null
                        }
                        onChange={(selectedOption: any) =>
                          formik.setFieldValue("country", selectedOption.value)
                        }
                        required
                        isError={
                          formik.touched.country &&
                          Boolean(formik.errors.country)
                        }
                        errorMessage={
                          formik.touched.country && formik.errors.country
                            ? String(formik.errors.country)
                            : undefined
                        }
                        className={`${formik.touched.country && formik.errors.country ? "border-red-300" : "border-gray-300"}`}
                        buttonClassName="react-select"
                        isSearchable={true}
                      />
                    </div>

                    {/* <div className="flex flex-col gap-1.5">
                      <Label text="State" required />
                      <Select
                        isDisabled={edit2}
                        placeholder="Select State"
                        options={State?.getStatesOfCountry(formik.values.country?.["isoCode"])}
                        getOptionLabel={(options: any) => options["name"]}
                        getOptionValue={(options: any) => options["name"]}
                        id="state"
                        name="state"
                        value={formik.values.state}
                        onBlur={formik.handleBlur}
                        onChange={(item: any) => formik.setFieldValue("state", item)}
                        className={` ${formik.touched.state && formik.errors.state ? 'border-red-300' : 'border-gray-300'} ${edit2 ? 'bg-gray-50' : 'border-gray-300'}`}
                        classNamePrefix="react-select"
                      />
                      {formik.touched.state && formik.errors.state && (
                        <p className="mt-2 text-sm text-red-600">{formik.errors.state}</p>
                      )}
                    </div> */}
                    <div className="flex flex-col gap-1.5">
                      <Label text="State" required />
                      <SearchableDropdown
                        disabled={edit2 || !formik.values.country}
                        placeholder="Select State"
                        options={
                          State?.getStatesOfCountry(
                            formik.values.country?.["isoCode"],
                          )?.map((state: any) => ({
                            label: state.name,
                            value: state, // Store entire state object
                            data: state,
                          })) || []
                        }
                        value={formik.values.state ? formik.values.state : null}
                        onChange={(selectedOption: any) => {
                          formik.setFieldValue("state", selectedOption.value);
                          // Clear city when state changes
                          formik.setFieldValue("city", null);
                        }}
                        required
                        isError={
                          formik.touched.state && Boolean(formik.errors.state)
                        }
                        errorMessage={
                          formik.touched.state && formik.errors.state
                            ? String(formik.errors.state)
                            : undefined
                        }
                        className={`${formik.touched.state && formik.errors.state ? "border-red-300" : "border-gray-300"} ${edit2 ? "bg-gray-50" : "border-gray-300"}`}
                        buttonClassName="react-select"
                        isSearchable={true}
                      />
                    </div>

                    {/* <div className="flex flex-col gap-1.5">
                      <Label text="City" required />
                      <Select
                        isDisabled={edit2}
                        placeholder="Select City"
                        options={City.getCitiesOfState(
                          formik.values.state?.["countryCode"]!,
                          formik.values.state?.["isoCode"]!
                        )}
                        getOptionLabel={(options: any) => options["name"]}
                        getOptionValue={(options: any) => options["name"]}
                        id="city"
                        name="city"
                        value={formik.values.city}
                        onBlur={formik.handleBlur}
                        onChange={(item: any) => formik.setFieldValue("city", item)}
                        className={`${formik.touched.city && formik.errors.city ? 'border-red-300' : 'border-gray-300'}`}
                        classNamePrefix="react-select"
                      />
                      {formik.touched.city && formik.errors.city && (
                        <p className="mt-2 text-sm text-red-600">{formik.errors.city}</p>
                      )}
                    </div> */}
                    <div className="flex flex-col gap-1.5">
                      <Label text="City" required />
                      <SearchableDropdown
                        disabled={edit2 || !formik.values.state}
                        placeholder="Select City"
                        options={
                          City.getCitiesOfState(
                            formik.values.state?.["countryCode"]!,
                            formik.values.state?.["isoCode"]!,
                          )?.map((city: any) => ({
                            label: city.name,
                            value: city, // Store entire city object
                            data: city,
                          })) || []
                        }
                        value={formik.values.city ? formik.values.city : null}
                        onChange={(selectedOption: any) =>
                          formik.setFieldValue("city", selectedOption.value)
                        }
                        required
                        isError={
                          formik.touched.city && Boolean(formik.errors.city)
                        }
                        errorMessage={
                          formik.touched.city && formik.errors.city
                            ? String(formik.errors.city)
                            : undefined
                        }
                        className={`${formik.touched.city && formik.errors.city ? "border-red-300" : "border-gray-300"}`}
                        buttonClassName="react-select"
                        isSearchable={true}
                      />
                    </div>

                    <CustomInput
                      disabled={edit2}
                      placeholder="Postal Code"
                      type="text"
                      name="postal_code"
                      label="Postal Code"
                      required
                      value={formik.values.postal_code}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      isError={
                        !!formik.touched.postal_code &&
                        !!formik.errors.postal_code
                      }
                      errorMessage={formik.errors.postal_code}
                    />

                    <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
                      <CustomInput
                        disabled={edit2}
                        placeholder="First Name"
                        type="text"
                        name="first_name"
                        label="First Name"
                        required
                        value={formik.values.first_name}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        isError={
                          !!formik.touched.first_name &&
                          !!formik.errors.first_name
                        }
                        errorMessage={formik.errors.first_name}
                      />

                      <CustomInput
                        disabled={edit2}
                        placeholder="Last Name"
                        type="text"
                        name="last_name"
                        label="Last Name"
                        required
                        value={formik.values.last_name}
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        isError={
                          !!formik.touched.last_name &&
                          !!formik.errors.last_name
                        }
                        errorMessage={formik.errors.last_name}
                      />
                    </div>

                    <CustomInput
                      disabled
                      placeholder="Phone Number"
                      type="text"
                      name="phoneNumber"
                      label="Phone Number"
                      value={formik.values.phoneNumber}
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      isError={
                        !!formik.touched.phoneNumber &&
                        !!formik.errors.phoneNumber
                      }
                      errorMessage={formik.errors.phoneNumber}
                    />
                  </div>
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>

      <Modal
        isOpen={changePass}
        onClose={() => setChangePass(false)}
        title="Change Password"
        children={
          <form onSubmit={formik1.handleSubmit} className=" p-4 space-y-4">
            <CustomInput
              type="password"
              name="old_pass"
              required
              label="Old Password"
              placeholder="Enter your current password"
              value={formik1.values.old_pass}
              onBlur={formik1.handleBlur}
              onChange={formik1.handleChange}
              isError={!!formik1.touched.old_pass && !!formik1.errors.old_pass}
              errorMessage={formik1.errors.old_pass}
              className="w-full"
            />
            <CustomInput
              type="password"
              name="new_pass"
              label="New Password"
              required
              placeholder="Enter your new password"
              value={formik1.values.new_pass}
              onBlur={formik1.handleBlur}
              onChange={formik1.handleChange}
              isError={!!formik1.touched.new_pass && !!formik1.errors.new_pass}
              errorMessage={formik1.errors.new_pass}
              className="w-full"
            />
            <CustomInput
              type="password"
              name="confirm_pass"
              label="Confirm Password"
              required
              placeholder="Confirm your new password"
              value={formik1.values.confirm_pass}
              onBlur={formik1.handleBlur}
              onChange={formik1.handleChange}
              isError={
                !!formik1.touched.confirm_pass && !!formik1.errors.confirm_pass
              }
              errorMessage={formik1.errors.confirm_pass}
              className="w-full"
            />

            <div className="  flex gap-3 justify-end">
              <button
                type="button"
                onClick={() => {
                  setChangePass(false);
                  formik1.resetForm();
                }}
                className="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors text-sm font-medium"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-violet-600 text-white rounded-lg hover:bg-violet-700 transition-colors text-sm font-medium"
              >
                Save Changes
              </button>
            </div>
          </form>
        }
      />
      <Modal
        isOpen={edit1}
        onClose={() => {
          setEdit1(false);
          setSelectedImage(prevImage);
        }}
        title="Edit Profile"
        children={
          <div className="relative flex flex-col gap-6">
            {userData?.profile || selectedImage ? (
              <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-slate-200 mx-auto">
                <img
                  className="w-full h-full object-cover"
                  src={selectedImage || userData?.profile}
                  alt="Organization Logo"
                />
              </div>
            ) : (
              <div className="w-32 h-32 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 mx-auto flex items-center justify-center">
                <svg
                  className="h-6 w-6 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  />
                </svg>
              </div>
            )}
            {fileError && (
              <div className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded-md border border-red-200 mb-4">
                {fileError}
              </div>
            )}
            <label className="cursor-pointer absolute top-[50%] right-[35%]">
              <div className="flex items-center justify-center p-1 bg-blue-500 rounded-full border border-blue-600 hover:bg-blue-600 transition-colors shadow-md">
                <MdEdit className="text-white text-md" />
              </div>
              <input
                type="file"
                className="hidden"
                onChange={handleImageChange}
              />
            </label>
            <div className="flex justify-end gap-2">
              <Button
                onClick={() => {
                  setEdit1(false);
                  setSelectedImage(prevImage);
                }}
                color="gray"
                text="Cancel"
                variant="outlined"
              />
              <Button
                onClick={() => updateProfilePic()}
                color="blue"
                text="Save"
              />
            </div>
          </div>
        }
      />
    </>
  );
};

export default OrgProfile;
